import React, { useState, useEffect } from "react";
import {
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  TextInput,
} from "react-native";
import Container from "../../common/Container";
import type { UserHabit } from "../types";
import { useNavigate } from "react-router-dom";

export type StateProps = {
  installedHabits: UserHabit[];
  availableHabits: UserHabit[];
};
export type DispatchProps = {
  loadAvailableHabits: (arg0: string | null | undefined, arg1: boolean) => void;
};
export type OwnProps = {};
export type Props = StateProps & DispatchProps & OwnProps;

function ManageHabitsButton(props: {
  title: string;
  description: string;
  onOpen: () => void;
  installed: boolean;
}) {
  return (
    <View style={styles.habitContainer}>
      <TouchableOpacity onPress={props.onOpen}>
        <View style={styles.buttonContainer}>
          <Text style={styles.buttonHeaderText}>{props.title}</Text>
          <Text>{props.description} </Text>
          <Text style={styles.dot}>{props.installed ? "◉" : "○"}</Text>
        </View>
      </TouchableOpacity>
    </View>
  );
}

export default function ManageHabits(props: Props) {
  const [query, setQuery] = useState(null);
  const typeIndex = 0;
  // const [typeIndex, setTypeIndex] = useState(0);
  const nav = useNavigate();
  const { loadAvailableHabits } = props;
  useEffect(() => {
    loadAvailableHabits(query, false);
  }, [query, typeIndex, loadAvailableHabits]);

  const openHabit = (userHabit: UserHabit) => {
    const { userId, createdms } = userHabit.habit;
    const [userId1, userId2] = userId.split(":");
    nav("/view/" + userId1 + "/" + userId2 + "/" + createdms);
  };

  const habits =
    typeIndex === 0 ? props.availableHabits : props.installedHabits;
  const buttons = habits.map((userHabit) => (
    <ManageHabitsButton
      key={userHabit.habit.habitId}
      title={userHabit.habit.title}
      description={userHabit.habit.description}
      installed={userHabit.installed === true}
      onOpen={() => openHabit(userHabit)}
    />
  ));
  return (
    <Container>
      <TextInput
        placeholder="Search"
        style={styles.searchBar}
        onChangeText={(text) => setQuery(text)}
      />
      {/* <SegmentedControl values={["All", "Installed"]} style={styles.typeControl} selectedIndex={typeIndex} onChange={event => {
        setTypeIndex(event.nativeEvent.selectedSegmentIndex);
      }} /> */}
      {buttons}
    </Container>
  );
}
const actionButtonStyle = {
  position: "absolute",
  top: 7,
  bottom: 7,
  right: 12,
  flex: 1,
  alignItems: "center",
  justifyContent: "center",
  width: 60,
  borderWidth: 0,
  borderRadius: 10,
};
const styles = StyleSheet.create({
  dot: {
    position: "absolute",
    right: 10,
    top: 10,
    fontSize: 25,
  },
  habitContainer: {},
  buttonContainer: {
    margin: 10,
    borderColor: "black",
    borderWidth: 1,
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 30,
    paddingRight: 30,
    borderRadius: 10,
  },
  buttonHeaderText: {
    fontSize: 20,
  },
  removeButton: { ...actionButtonStyle },
  addButton: { ...actionButtonStyle },
  searchBar: {
    padding: 7,
    margin: 10,
    alignSelf: "stretch",
  },
  typeControl: {
    alignSelf: "stretch",
  },
});
